import { createBrowserRouter, Navigate } from 'react-router-dom'
import LoginPage from '../pages/Login'
import Dashboard from '../pages/Dashboard'
import AppLayout from '../components/layout/AppLayout'
import ProtectedRoute from '../components/ProtectedRoute'
import ProveedoresPage from '../pages/Proveedores'
import NuevoProveedorPage from '../pages/Proveedores/NuevoProveedor'
import ProveedorDetallePage from '../pages/Proveedores/DetalleProveedor'
import EvaluarProveedorPage from '../pages/Proveedores/EvaluarProveedor'
import ExpedientesPage from '../pages/Expedientes'
import DetalleExpedientePage from '../pages/Expedientes/DetalleExpediente'
import ExpedienteElectronicoPage from '../pages/Expedientes/ExpedienteElectronico'
import ModificarWizardPage from '../pages/Proveedores/ModificarWizard'
import HistorialModificacionesPage from '../pages/Proveedores/HistorialModificaciones'
import VerificarPage from '../pages/Verificar'
import PoliticaPrivacidadPage from '../pages/PoliticaPrivacidad'
import TransportistasPage from '../pages/Transportistas'
import NuevoTransportistaPage from '../pages/Transportistas/NuevoTransportista'
import RegularizarVehiculosPage from '../pages/Transportistas/RegularizarVehiculos'
import EvaluarTransportistaPage from '../pages/Transportistas/EvaluarTransportista'
import PlantasPage from '../pages/Plantas'
import NuevaPlantaPage from '../pages/Plantas/NuevaPlanta'
import MiEmpresaPage from '../pages/MiEmpresa'
import PersonasPage from '../pages/Personas'
import NuevaPersonaPage from '../pages/Personas/NuevaPersona'
import EstadisticasPage from '../pages/Estadisticas'
import DetalleProveedoresPage from '../pages/Estadisticas/DetalleProveedores'
import DetalleProveedorPage from '../pages/Estadisticas/DetalleProveedor'
import DetalleMineralesPage from '../pages/Estadisticas/DetalleMinerales'
import DetalleRutasPage from '../pages/Estadisticas/DetalleRutas'
import DetalleTransportistasPage from '../pages/Estadisticas/DetalleTransportistas'
import ProgramacionesPage from '../pages/Programaciones'
import NuevaProgramacionPage from '../pages/Programaciones/NuevaProgramacion'
import DetalleProgramacionPage from '../pages/Programaciones/DetalleProgramacion'
import VisitaDetallePage from '../pages/Programaciones/VisitaDetalle'
import InformesVerificacionPage from '../pages/Origen/Informes'
import TrasladosPage from '../pages/Traslados'
import MonitoreoTransportePage from '../pages/Traslados/MonitoreoTransporte'
import DetalleRecorridoPage from '../pages/Traslados/DetalleRecorrido'
import UsuariosPage from '../pages/Usuarios'
import NuevoUsuarioPage from '../pages/Usuarios/NuevoUsuario'
import AuditoriaPage from '../pages/Auditoria'
import DetalleTablaPage from '../pages/Auditoria/DetalleTabla'
import HistorialEntidadPage from '../pages/Auditoria/HistorialEntidad'
import RecpoPage from '../pages/Sincronizaciones/RecpoPage'
import MinerosFormalesPage from '../pages/Sincronizaciones/MinerosFormalesPage'
import ReinfoPage from '../pages/Sincronizaciones/ReinfoPage'
import AuditoriaEmergenciaPage from '../pages/Inteligencia/AuditoriaEmergencia'
import MapaVerificacionesPage from '../pages/Inteligencia/MapaVerificaciones'
import ZonasRestringidasPage from '../pages/Inteligencia/ZonasRestringidas'
import MapaOrigenMineralPage from '../pages/Analitica/MapaOrigenMineral'
import RiesgoProveedoresPage from '../pages/Analitica/RiesgoProveedores'
import ProyeccionCajaPage from '../pages/Analitica/ProyeccionCaja'
import EstabilidadLaborPage from '../pages/Analitica/EstabilidadLabor'
import CuellosBotellaPage from '../pages/Analitica/CuellosBotella'
import SostenibilidadPage from '../pages/Analitica/Sostenibilidad'
import ConfiguracionAnaliticaPage from '../pages/Analitica/ConfiguracionAnalitica'
import ComponentesMinerosPage from '../pages/Origen/ComponentesMineros'
import LiquidacionesPage from '../pages/Liquidaciones'
import NuevaLiquidacionPage from '../pages/Liquidaciones/NuevaLiquidacion'
import LiquidarLotePage from '../pages/Liquidaciones/LiquidarLote'
import ConciliacionPage from '../pages/Conciliacion'
import HistorialVentasPage from '../pages/Cierre/HistorialVentas'
import BalanzaPage from '../pages/Planta/Balanza'
import LaboratorioPage from '../pages/Planta/Laboratorio'
import ControlIngresoPage from '../pages/Planta/ControlIngreso'
import ControlIngresoDetallePage from '../pages/Planta/ControlIngreso/Detalle'
import RecepcionesPage from '../pages/Recepciones'
import NuevaRecepcionPage from '../pages/Recepciones/NuevaRecepcion'
import ValidacionProgresoPage from '../pages/Recepciones/ValidacionProgreso'
import ResultadoValidacionPage from '../pages/Recepciones/ResultadoValidacion'
import DetalleRecepcionPage from '../pages/Recepciones/DetalleRecepcion'
import RolesPage from '../pages/Maestros/Roles'
import MineralTypesPage from '../pages/Maestros/MineralTypes'
import MeasurementUnitsPage from '../pages/Maestros/MeasurementUnits'
import ValidacionesRecepcionPage from '../pages/Maestros/ValidacionesRecepcion'
import BusinessTypeCategoriesPage from '../pages/Maestros/BusinessTypeCategories'
import MotivosDespachoPage from '../pages/Maestros/MotivosDespacho'
import TiposVehiculoPage from '../pages/Maestros/TiposVehiculo'
import FuelTypesPage from '../pages/Maestros/FuelTypes'
import MotivosObservacionPage from '../pages/Maestros/MotivosObservacion'
import MotivosPausaPage from '../pages/Maestros/MotivosPausa'
import ComponentCategoriesPage from '../pages/Maestros/ComponentCategories'
import ComponentTiersPage from '../pages/Maestros/ComponentTiers'
import ComponentTypesPage from '../pages/Maestros/ComponentTypes'
import OcdeMaestrosPage from '../pages/Maestros/Ocde'
import ConsentimientoPage from '../pages/Maestros/Consentimiento'
import EditorConsentimientoPage from '../pages/Maestros/Consentimiento/EditorConsentimiento'
import TenantsAdminPage from '../pages/TenantsAdmin'
import PermissionsAdminPage from '../pages/Admin/Permissions'
import RolePermissionsAdminPage from '../pages/Admin/RolePermissions'
import MenusAdminPage from '../pages/Admin/Menus'
import ComercializadoresPage from '../pages/Comercializadores'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  // PÚBLICA Y FUERA DE `/app` A PROPÓSITO: no lleva `ProtectedRoute` ni `AppLayout`.
  // Es la puerta a la que llevan los QR impresos —el CUID de la carátula y el CVD del
  // Índice Digital comparten esta MISMA ruta, ver `PublicWebUrlResolver`—, y quien la
  // abre no tiene cuenta. Sin el código se puede teclear a mano desde el papel.
  {
    path: '/verificar',
    element: <VerificarPage />,
  },
  {
    path: '/verificar/:code',
    element: <VerificarPage />,
  },
  {
    path: '/politica-privacidad',
    element: <PoliticaPrivacidadPage />,
  },
  {
    path: '/app',
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="/app/dashboard" replace />,
          },
          {
            path: 'dashboard',
            element: <Dashboard />,
          },
          // Empresas redirect
          {
            path: 'empresas',
            element: <Navigate to="/app/proveedores" replace />,
          },
          // Proveedores
          {
            path: 'proveedores',
            element: <ProveedoresPage />,
          },
          {
            path: 'proveedores/nuevo',
            element: <NuevoProveedorPage />,
          },
          {
            path: 'proveedores/:id',
            element: <NuevoProveedorPage />,
          },
          {
            path: 'proveedores/:id/detalle',
            element: <ProveedorDetallePage />,
          },
          {
            path: 'proveedores/:id/evaluar',
            element: <EvaluarProveedorPage />,
          },
          {
            path: 'proveedores/:id/modificar/:mrId',
            element: <ModificarWizardPage />,
          },
          {
            path: 'proveedores/:id/modificaciones',
            element: <HistorialModificacionesPage />,
          },
          // Expedientes (Audit Dossier)
          {
            path: 'identidad/expedientes',
            element: <ExpedientesPage />,
          },
          {
            path: 'identidad/expedientes/:code',
            element: <DetalleExpedientePage />,
          },
          // Vista ARCHIVÍSTICA del mismo expediente (índice digital foliado,
          // series documentales y versiones selladas). La de arriba es la operativa.
          {
            path: 'identidad/expedientes/:code/electronico',
            element: <ExpedienteElectronicoPage />,
          },
          // Transportistas
          // Mock de la demo Kuntur Comercializadores (ver auth/mockMenuItems.ts)
          {
            path: 'comercializadores',
            element: <ComercializadoresPage />,
          },
          {
            path: 'transportistas',
            element: <TransportistasPage />,
          },
          {
            path: 'transportistas/nuevo',
            element: <NuevoTransportistaPage />,
          },
          {
            path: 'transportistas/regularizar',
            element: <RegularizarVehiculosPage />,
          },
          {
            path: 'transportistas/:id',
            element: <NuevoTransportistaPage />,
          },
          {
            path: 'transportistas/:id/evaluar',
            element: <EvaluarTransportistaPage />,
          },
          // Plantas
          {
            path: 'plantas',
            element: <PlantasPage />,
          },
          {
            path: 'plantas/nuevo',
            element: <NuevaPlantaPage />,
          },
          {
            path: 'plantas/:id',
            element: <NuevaPlantaPage />,
          },
          // Mi Empresa
          {
            path: 'settings',
            element: <MiEmpresaPage />,
          },
          // Personas
          {
            path: 'personas',
            element: <PersonasPage />,
          },
          {
            path: 'personas/nuevo',
            element: <NuevaPersonaPage />,
          },
          {
            path: 'personas/:id',
            element: <NuevaPersonaPage />,
          },
          // Estadisticas
          {
            path: 'estadisticas',
            element: <EstadisticasPage />,
          },
          {
            path: 'estadisticas/proveedores',
            element: <DetalleProveedoresPage />,
          },
          {
            path: 'estadisticas/proveedores/:proveedorId',
            element: <DetalleProveedorPage />,
          },
          {
            path: 'estadisticas/minerales',
            element: <DetalleMineralesPage />,
          },
          {
            path: 'estadisticas/rutas',
            element: <DetalleRutasPage />,
          },
          {
            path: 'estadisticas/transportistas',
            element: <DetalleTransportistasPage />,
          },
          // Programaciones
          {
            path: 'programaciones',
            element: <ProgramacionesPage />,
          },
          {
            path: 'programaciones/nuevo',
            element: <NuevaProgramacionPage />,
          },
          {
            path: 'programaciones/:id',
            element: <NuevaProgramacionPage />,
          },
          {
            path: 'programaciones/:id/detalle',
            element: <DetalleProgramacionPage />,
          },
          {
            path: 'programaciones/:id/details/:detailId/visita',
            element: <VisitaDetallePage />,
          },
          // Origen / Informes de Verificación
          {
            path: 'origen/informes',
            element: <InformesVerificacionPage />,
          },
          // Recepciones
          {
            path: 'recepciones',
            element: <RecepcionesPage />,
          },
          {
            path: 'recepciones/nueva',
            element: <NuevaRecepcionPage />,
          },
          {
            path: 'recepciones/:id/validar',
            element: <ValidacionProgresoPage />,
          },
          {
            path: 'recepciones/:id/resultado',
            element: <ResultadoValidacionPage />,
          },
          {
            path: 'recepciones/:id',
            element: <DetalleRecepcionPage />,
          },
          // Logística
          {
            path: 'traslados',
            element: <TrasladosPage />,
          },
          {
            path: 'traslados/:id',
            element: <DetalleRecorridoPage />,
          },
          {
            path: 'logistica/monitoreo',
            element: <MonitoreoTransportePage />,
          },
          // Usuarios
          {
            path: 'usuarios',
            element: <UsuariosPage />,
          },
          {
            path: 'usuarios/:id',
            element: <NuevoUsuarioPage />,
          },
          // Auditoria
          {
            path: 'auditoria',
            element: <AuditoriaPage />,
          },
          {
            path: 'auditoria/:entityName',
            element: <DetalleTablaPage />,
          },
          {
            path: 'auditoria/:entityName/:entityId',
            element: <HistorialEntidadPage />,
          },
          // Analitica
          {
            path: 'analitica/mapa-origen-mineral',
            element: <MapaOrigenMineralPage />,
          },
          {
            path: 'analitica/riesgo-proveedores',
            element: <RiesgoProveedoresPage />,
          },
          {
            path: 'analitica/proyeccion-caja',
            element: <ProyeccionCajaPage />,
          },
          {
            path: 'analitica/estabilidad-labor',
            element: <EstabilidadLaborPage />,
          },
          {
            path: 'analitica/cuellos-botella',
            element: <CuellosBotellaPage />,
          },
          {
            path: 'analitica/sostenibilidad',
            element: <SostenibilidadPage />,
          },
          {
            path: 'analitica/configuracion',
            element: <ConfiguracionAnaliticaPage />,
          },
          // Inteligencia
          {
            path: 'inteligencia/emergencia',
            element: <AuditoriaEmergenciaPage />,
          },
          {
            path: 'inteligencia/verificaciones',
            element: <MapaVerificacionesPage />,
          },
          {
            path: 'inteligencia/zonas-restringidas',
            element: <ZonasRestringidasPage />,
          },
          // Origen
          {
            path: 'origen/componentes',
            element: <ComponentesMinerosPage />,
          },
          // Conciliacion (Comercial)
          {
            path: 'cierre/conciliacion',
            element: <ConciliacionPage />,
          },
          // Liquidaciones
          {
            path: 'cierre/liquidaciones',
            element: <LiquidacionesPage />,
          },
          {
            path: 'cierre/liquidaciones/nueva',
            element: <NuevaLiquidacionPage />,
          },
          {
            path: 'cierre/liquidaciones/:shipmentId/liquidar',
            element: <LiquidarLotePage />,
          },
          // Historial de Ventas — Vista 360° del Proveedor
          {
            path: 'cierre/historial-ventas',
            element: <HistorialVentasPage />,
          },
          // Planta (Balanza + Laboratorio + Control de Ingreso)
          {
            path: 'planta/balanza',
            element: <BalanzaPage />,
          },
          {
            path: 'planta/laboratorio',
            element: <LaboratorioPage />,
          },
          {
            path: 'planta/garita',
            element: <ControlIngresoPage />,
          },
          {
            path: 'planta/garita/:id',
            element: <ControlIngresoDetallePage />,
          },
          // Sincronizaciones (legacy redirect + individual pages)
          {
            path: 'sincronizaciones',
            element: <Navigate to="/app/sincronizaciones/recpo" replace />,
          },
          {
            path: 'sincronizaciones/recpo',
            element: <RecpoPage />,
          },
          {
            path: 'sincronizaciones/mineros-formales',
            element: <MinerosFormalesPage />,
          },
          {
            path: 'sincronizaciones/reinfo',
            element: <ReinfoPage />,
          },
          // Maestros (Catalogs)
          {
            path: 'maestros/roles',
            element: <RolesPage />,
          },
          {
            path: 'maestros/tipos-mineral',
            element: <MineralTypesPage />,
          },
          {
            path: 'maestros/unidades-medida',
            element: <MeasurementUnitsPage />,
          },
          {
            path: 'maestros/validaciones-recepcion',
            element: <ValidacionesRecepcionPage />,
          },
          {
            path: 'maestros/tipos-negocio',
            element: <BusinessTypeCategoriesPage />,
          },
          {
            path: 'maestros/motivos-despacho',
            element: <MotivosDespachoPage />,
          },
          {
            path: 'maestros/tipos-vehiculo',
            element: <TiposVehiculoPage />,
          },
          {
            path: 'maestros/factores-emision',
            element: <FuelTypesPage />,
          },
          {
            path: 'maestros/motivos-observacion',
            element: <MotivosObservacionPage />,
          },
          {
            path: 'maestros/motivos-pausa',
            element: <MotivosPausaPage />,
          },
          {
            path: 'maestros/categorias-componente',
            element: <ComponentCategoriesPage />,
          },
          {
            path: 'maestros/tipos-componente',
            element: <ComponentTypesPage />,
          },
          {
            path: 'maestros/niveles-componente',
            element: <ComponentTiersPage />,
          },
          {
            path: 'maestros/ocde',
            element: <OcdeMaestrosPage />,
          },
          // Tenant administration (platform users only — page itself gates).
          // Lives under Maestros so it shows up alongside other catalogs.
          {
            path: 'maestros/organizaciones',
            element: <TenantsAdminPage />,
          },
          {
            path: 'maestros/consentimiento',
            element: <ConsentimientoPage />,
          },
          {
            path: 'maestros/consentimiento/:id',
            element: <EditorConsentimientoPage />,
          },
          // Permissions administration
          {
            path: 'admin/permissions',
            element: <PermissionsAdminPage />,
          },
          {
            path: 'admin/roles/:id/permissions',
            element: <RolePermissionsAdminPage />,
          },
          {
            path: 'admin/menus',
            element: <MenusAdminPage />,
          },
        ],
      },
    ],
  },
])
